import React from 'react';
import { FiUser } from 'react-icons/fi';
import { motion, AnimatePresence } from "framer-motion";

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { staggerChildren: 0.08, delayChildren: 0.1 }
    }
};

const itemVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: { opacity: 1, x: 0, transition: { type: "spring", stiffness: 100 } }
};

const OnlineUsers = ({ users = [] }) => {
    return (
        <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="space-y-3 max-h-[320px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-300"
        >
            <AnimatePresence>
                {users && users.length > 0 ? (
                    users.map((user, index) => (
                        <motion.div
                            key={user.uuid || `user-${index}`}
                            variants={itemVariants}
                            initial="hidden"
                            animate="visible"
                            exit="hidden"
                            className="flex items-center gap-3 p-3 bg-gray-50 hover:bg-gray-100 rounded-xl transition-colors cursor-pointer"
                        >
                            <div className="relative">
                                <img
                                    src={user?.image_url || 'https://placehold.co/40x40/3b82f6/ffffff?text=U'}
                                    alt={user?.user?.name}
                                    className="w-11 h-11 rounded-full object-cover ring-2 ring-white shadow-sm"
                                />
                                <span className="absolute bottom-0 right-0 w-3 h-3 bg-emerald-500 border-2 border-white rounded-full" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="font-medium text-gray-900 truncate">
                                    {user?.user?.name || 'Anonymous User'}
                                </p>
                                <p className="text-xs text-gray-500">
                                    {user?.last_seen
                                        ? `Last seen: ${new Date(user.last_seen).toLocaleTimeString()}`
                                        : 'Active now'}
                                </p>
                            </div>
                            <span className="px-2 py-1 bg-emerald-100 text-emerald-600 text-xs font-medium rounded-full">
                                Online
                            </span>
                        </motion.div>
                    ))
                ) : (
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            className="flex flex-col items-center justify-center py-8 text-center"
                        >
                            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                            <FiUser className="w-8 h-8 text-gray-400" />
                        </div>
                        <p className="text-gray-500 font-medium">No users online</p>
                        <p className="text-sm text-gray-400 mt-1">Users will appear here when they're active</p>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
};

export default OnlineUsers;